import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { localeLowerCase, localeUpperCase } from 'src/app/utils/locale-case.util';

@Pipe({
  name: 'capitalize',
  standalone: true,
})
export class CapitalizePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: string): string {
    if (!value) return value;
    const locale = this.translocoService.getActiveLang() || 'en';
    return (
      localeUpperCase(value.charAt(0), locale) +
      localeLowerCase(value.slice(1), locale)
    );
  }
}
